﻿module.exports = (function ($, mustache, urlParameters) {
    return {
        hasResults: false,
        isLegacySearch: null,
        isNewSearch: null,
        init: function () {
            // Used to reference 'this' inside anonymous functions (e.g. click events)
            var self = this;
            this.isLegacySearch = $(".meDbSearch").length > 0;
            this.isNewSearch = $(".meDbOutcomesSearch").length > 0;
            if (this.isLegacySearch || this.isNewSearch)
                this.initForm();

            $(window).resize(function () {
                $('.select2').css('width', "100%");
            });

            // If we are on the result details page set the accordians.
            var isDetailsPage = $('.disasterEvaluations').length > 0;
            if (isDetailsPage)
            {
                $('.disasterDocumentList__summary__heading').on('click', function (e) {
                    $(this).parent().toggleClass("show");
                    $(this).parent().find('.disasterDocumentList__summary__content').show();
                    e.stopPropagation();
                });

                this.initDisasterDetailsPage();
            }
            
        },
        toggleFilters: function(){
            var self = this;
            $('.meDbSearch__row').slideToggle({
                complete: function () {
                    if (self.isLegacySearch && self.hasResults && $('#hide_show_filters').hasClass('hide')) {
                        // Scroll to the top of the results
                        $('html, body').animate({
                            scrollTop: $('#search_results').offset().top - 212
                        }, 300);
                    }
                }
            });
            $('#hide_show_filters').toggleClass('hide');
            if ($('#hide_show_filters').hasClass('hide'))
                $('#hide_show_filters').text('Show Filters');
            else
                $('#hide_show_filters').text('Hide Filters');
        },
        initDisasterDetailsPage: function () {

            function base64ToArrayBuffer(base64) {
                var binaryString = window.atob(base64);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                return bytes;
            }

            function saveByteArray(reportName, byte) {
                
				var blob = new Blob([byte], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
				var fileName = reportName + ".xlsx";
				var link = document.createElement("a");
				document.body.appendChild(link)

				if (window.navigator.msSaveOrOpenBlob) {				
					window.navigator.msSaveOrOpenBlob(new Blob([byte]), fileName);
				} else {
					link.href = window.URL.createObjectURL(blob);
					link.download = fileName;
					link.click();
				}
            }

            $('.oai-export-excel').on('click', function (e) {
                               
                var formData = {
                    evaluationId: this.getAttribute('data-evaluation-id')
                }
                
                $.ajax({
                    url: '/umbraco/surface/medb/OutcomesSearchExportExcel',
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    data: JSON.stringify(formData),
                    success: function (data) {
                        var sampleArr = base64ToArrayBuffer(data.base64str);
                        saveByteArray("AIDR Recovery Outcomes - Activities and Indicators", sampleArr);
                    },
                    error: function (result) {
                        console.log(result);
                    }
                });
            });
        },
        initForm: function () {
            var self = this;

            // Set the hide show filter functionality
            if (self.isLegacySearch) {
                $('#hide_show_filters').on('click', function () {
                    self.toggleFilters();
                });
            }

            // Set page urls and hidden fields
            var page = urlParameters.param('page') || 1;
            var resultsPerPage = urlParameters.param('results') || 5;
            $('#page').val(page);
            $('#results_per_page').val(resultsPerPage);

            $('#results_per_page').change(function () {
                // Reset the page number to 1
                $('#page').val(1);
                // Get new results
                var formData = self.getFormData();
                self.search(formData);
            });

            // Set the click events on the previous and next buttons
            $('.meDbSearch__results__pagination .prev').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                var page = parseInt($('#page').val()) - 1;
                if (page > 0) {
                    $('#page').val(page);
                    var formData = self.getFormData();
                    self.search(formData);
                }
            });
            $('.meDbSearch__results__pagination .next').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                var page = parseInt($('#page').val()) + 1;
                if (page <= $('#pagination').data('pages')) {
                    $('#page').val(page);
                    var formData = self.getFormData();
                    self.search(formData);
                }
            });

            $("#clear-filters").click(function (e) {
                e.preventDefault();
                $("#disaster_name").val(null);
                $('#disaster_type').val([]).trigger("change");
                $('#jurisdiction').val([]).trigger("change");
                $('#domain').val([]).trigger("change");
                $('#indicator_category').val([]).trigger("change");
                $('#date_from').val(null);
                $('#date_to').val(null);
            });

            var resultData = null;
            // get field loader data from API cached calls.
            $.ajax({
                url: '/umbraco/surface/medb/metadata',
                type: 'GET',
                dataType: 'json',
                success: function (data) {
                    // load select lists.
                    console.log(data)
                    resultData = data;
                },
                error: function (result) {
                    console.log(result);
                },
                complete: function (jqXHR, textStatus) {
                    // enable search btn
                    if (textStatus == "success")
                    {
                        self.buildSelect('#domain', resultData.domains);
                        self.buildSelect('#disaster_type', resultData.disaster_types);
                        self.buildSelect('#jurisdiction', resultData.jurisdictions);
                        self.buildSelect('#indicator_category', resultData.categories);
                    }

                    // set select2 links
                    var settings = {
                        placeholder: "All",
                        allowClear: false,
                        width: '100%'
                    }

                    $('#domain, #disaster_type, #jurisdiction, #indicator_category').select2(settings);
                }
            });

            $(".meDbSearch__form").submit(function (e) {
                e.preventDefault();
                var formData = self.getFormData();
                console.log(formData);
                self.search(formData);
            });
        },
        buildSelect: function (id, jsonData) {

            // Load up the tags filter with the tags from the 
            $(id).empty().append($('<option>', {
                value: '',
                text: 'All tags'
            }));

            $.each(jsonData, function (i, value) {
                $(id).append($('<option>', {
                    value: value.id,
                    text: value.title
                }));
            });

        },
        getFormData: function () {
            var form = {
                outcomes: $.map($('#outcomeIds').val().split(',').filter(function (x) { return x; }), function (value) {
                    return parseInt(value, 10);
                }),
                name: $('#disaster_name').val(),
                disasterTypes: $('#disaster_type').val(),
                jurisdictions: $('#jurisdiction').val(),
                dateFrom: $('#date_from').val().length > 0 ? $('#date_from').val() + '-12-31' : '',
                dateTo: $('#date_to').val().length > 0 ? $('#date_to').val() + '-01-01' : '',
                categories: $('#indicator_category').val(),
                domains: $('#domain').val(),
                pageNumber: $('#page').val(),
                pageSize: $('#results_per_page').val()
                
            }
            return form;
        },
        createResultsList: function(json)
        {
            var self = this;

            // Populate search list template
            var template = $('#results-template').html();
            mustache.parse(template);

            // Format date
            for (let i in json.data) {
                json.data[i].start_date = window.moment(json.data[i].start_date).utc().format('DD/MM/YYYY');
            }

            var rendered = mustache.render(template, {
                items: json.data, lower: function () {
                return function (text, render) {
                    return render(text).toLowerCase();
                }
            }});
            $('#results_list').empty().html(rendered);

            // Set the result counts
            if (json.data && json.data.length > 0) {
                var resultsStart = ((json.current_page - 1) * json.items_per_page) + 1;
                var resultsEnd = ((json.current_page - 1) * json.items_per_page) + json.data.length;
                $('.meDbSearchResults__results__header__count--value').text(resultsStart + '-' + resultsEnd + ' of ' + json.total_items);
                if (self.isNewSearch) {
                    $('#resultsResourcesList').html('');
                }

                // Build the pagination links
                var resultsPerPage = $("#results_per_page").val() || 5;
                var pages = json.total_pages;
                var selectedPage = ((resultsStart - 1) / resultsPerPage) + 1;
                var startPage = Math.max(selectedPage - 3, 1);
                var endPage = Math.min(selectedPage + 3, pages);
                if (selectedPage <= 3) endPage = Math.min(endPage + (4 - selectedPage), pages);
                if (selectedPage > pages - 3) startPage = Math.max(pages - 6, 1);
                $('#pagination').empty();
                $('#pagination').data('pages', pages);
                for (var page = startPage; page <= endPage; page++) {
                    var selected = (page - 1) * resultsPerPage == resultsStart - 1;
                    $('#pagination').append('<a href="#' + page + '" class="pagination__link ' + (selected ? 'selected' : '') + '">' + (page < 10 ? "0" + page : page) + '</a>');
                }
                $('.meDbSearchResults__results__pagination').show();
                $('#pagination .pagination__link').click(function (e) {
                    e.preventDefault();
                    if (!$(this).hasClass('selected')) {
                        $('#page').val($(this).attr('href').replace('#', ''));
                        var formData = self.getFormData();
                        self.search(formData);
                    }
                });

                // Show the results
                if (self.isLegacySearch) {
                    $('.meDbSearchResults__results__footer').css('visibility', 'visible');
                    $('#results_per_page').show();
                    $("#hide_show_filters").show();
                    if ($('.meDbSearch__row').is(":visible"))
                        self.toggleFilters();
                }
                self.hasResults = true;
                $('.meDbSearchResults').show();

            } else {

                if (self.isNewSearch) {
                    $('#resultsResourcesList').html('<h4>Your search returned no activities.</h4>');
                }
                if (self.isLegacySearch) {
                    $('.meDbSearchResults__results__header__count--value').text('Your search returned no results.');
                    $('.meDbSearchResults__results__footer').css('visibility', 'hidden');
                    $('#results_per_page').hide();
                    $("#hide_show_filters").hide();
                    $('.meDbSearchResults').show();
                }
                self.hasResults = false;

                if (self.isLegacySearch) {
                    // Scroll to the top of the results
                    $('html, body').animate({
                        scrollTop: $('#search_results').offset().top - 212
                    }, 300);
                }
            }
            if (self.isLegacySearch) {
                $('.meDbSearchResults__results__header').css('display', 'flex');
            }
            
        },
        search: function (formData) {
            var self = this;
            // Perform and ajax search
            $.ajax({
                url: "/umbraco/surface/medb/search",
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(formData),
                success: function (json) {
                    if (self.isNewSearch && json.data) {
                        $('#resourcesCount').html(json.data.length);
                    }

                    // Create list below calendar.
                    self.createResultsList(json);

                    $('.meDbOutcomesSearch__spinner').triggerHandler('stop');
                },
                error: function (result) {
                    // show error message
                },
                complete: function () {

                }
            });
        }
    };
});